import React, { type FC, type ReactNode } from "react";

interface HeaderProps {
  children: ReactNode;
}

export const PageHeader: FC<HeaderProps> = (props) => {
  return (
    <h1
      className={
        "h-12 inline-block text-3xl mb-8 mt-6 font-bold font-display text-primary relative"
      }
    >
      {props.children}
      <div className={"absolute -bottom-1 left-0 h-2 w-[min(60px,50%)] bg-secondary"}></div>
    </h1>
  );
};
